module.exports = __webpack_public_path__ + "img/annotation-x.c1f0a3b8.svg";